<template>
  <div class="editor_wrapper">
    <div class="content">
      <el-row>
        <el-col :span="FilesWidth">
          <div class="left">
            <div class="left_up">
              <span class="left_up_title"> 项目区 </span>

              <span class="left_up_icon" @click="CloseFiles">
                <i style="
                    font-size: 18px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12),
                      0 0 6px rgba(0, 0, 0, 0.04);
                  " class="el-icon-d-arrow-left"></i>
              </span>


              <span class="left_up_icon" @click="AddFloderFoot">


                <svg t="1657092897020" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="3149" width="20" height="20">
                  <path
                    d="M855.04 385.024q19.456 2.048 38.912 10.24t33.792 23.04 21.504 37.376 2.048 54.272q-2.048 8.192-8.192 40.448t-14.336 74.24-18.432 86.528-19.456 76.288q-5.12 18.432-14.848 37.888t-25.088 35.328-36.864 26.112-51.2 10.24l-567.296 0q-21.504 0-44.544-9.216t-42.496-26.112-31.744-40.96-12.288-53.76l0-439.296q0-62.464 33.792-97.792t95.232-35.328l503.808 0q22.528 0 46.592 8.704t43.52 24.064 31.744 35.84 12.288 44.032l0 11.264-53.248 0q-40.96 0-95.744-0.512t-116.736-0.512-115.712-0.512-92.672-0.512l-47.104 0q-26.624 0-41.472 16.896t-23.04 44.544q-8.192 29.696-18.432 62.976t-18.432 61.952q-10.24 33.792-20.48 65.536-2.048 8.192-2.048 13.312 0 17.408 11.776 29.184t29.184 11.776q31.744 0 43.008-39.936l54.272-198.656q133.12 1.024 243.712 1.024l286.72 0z"
                    p-id="3150" fill="#f3ca7e"></path>
                </svg>

              </span>



              <span class="left_up_icon" @click="AddPyFileFoot">

                <svg t="1657092936346" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="3336" width="20" height="20">
                  <path
                    d="M815.104 69.632q27.648 25.6 44.032 42.496t25.088 28.672 10.752 19.968 2.048 14.336l0 16.384-151.552 0q-10.24 0-17.92-7.68t-12.8-17.92-7.68-20.992-2.56-16.896l0-126.976 3.072 0q8.192 0 16.896 2.56t19.968 9.728 28.16 20.48 42.496 35.84zM640 129.024q0 20.48 6.144 42.496t19.456 40.96 33.792 31.232 48.128 12.288l149.504 0 0 577.536q0 29.696-11.776 53.248t-31.232 39.936-43.008 25.6-46.08 9.216l-503.808 0q-19.456 0-42.496-11.264t-43.008-29.696-33.28-41.984-13.312-49.152l0-696.32q0-21.504 9.728-44.544t26.624-42.496 38.4-32.256 45.056-12.8l391.168 0 0 128zM704.512 768q26.624 0 45.056-18.944t18.432-45.568-18.432-45.056-45.056-18.432l-384 0q-26.624 0-45.056 18.432t-18.432 45.056 18.432 45.568 45.056 18.944l384 0zM768 448.512q0-26.624-18.432-45.568t-45.056-18.944l-384 0q-26.624 0-45.056 18.944t-18.432 45.568 18.432 45.056 45.056 18.432l384 0q26.624 0 45.056-18.432t18.432-45.056z"
                    p-id="3337" fill="#1296db"></path>
                </svg>

              </span>
            </div>
            <div class="left_down">
              <el-tree ref="tree" class="filelist" :data="filelist" node-key="id" highlight-current default-expand-all
                :expand-on-click-node="false" @node-click="FileOnselect">
                <span style="width: 100%" slot-scope="{ node, data }">
                  <span style="font-size: 16px">
                    <i v-if="data.type == 'py'" class="el-icon-document"></i>

                    <i style="color: #F3C97E" v-else-if="data.type == 'folder' && node.expanded"
                      class="el-icon-folder-opened"></i>

                    <i style="color: #F3C97E" v-else-if="data.type == 'folder' && !node.expanded"
                      class="el-icon-folder"></i>

                    <i v-else-if="data.type == 'picture'" class="el-icon-picture"></i>
                    {{ node.label }}
                  </span>

                  <el-dropdown style="position: absolute; right: 20px" v-if="node.isCurrent">
                    <span>
                      <i class="el-icon-more el-icon--right"></i>
                    </span>

                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="data.type !== 'folder'" @click.native="RenameFile(node, data)">重命名
                      </el-dropdown-item>

                      <el-dropdown-item v-if="data.type == 'folder'" @click.native="AddPyFile">新建py文件</el-dropdown-item>

                      <el-dropdown-item v-if="data.type == 'folder'" @click.native="AddFloder">新建文件夹</el-dropdown-item>

                      <el-dropdown-item @click.native="DeleteFile">删除文件</el-dropdown-item>
                      <el-dropdown-item @click.native="OpenFolder(node, data)">打开文件位置</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </el-tree>
            </div>
          </div>
        </el-col>

        <el-col :span="24 - FilesWidth">
          <div class="right">
            <el-row>
              <el-col :span="EditorWidth">
                <div class="editor-wrapper" :style="{ height: Editor_Height }">
                  <div class="editor_up">
                    <span v-if="FilesWidth == 0" class="files_open_icon" @click="OpenFiles">
                      <i class="el-icon-arrow-right"></i>
                    </span>
                    <span v-else class="editor_up_title">代码区</span>

                    <span v-if="!is_photo" class="filename">{{ work_title }}
                    </span>

                    <span v-else class="filename">{{
                      work_title +
                      "(" +
                      is_photo_width +
                      "x" +
                      is_photo_height +
                      ")"
                    }}
                    </span>

                    <el-popover placement="bottom" width="600" trigger="click">
                      <el-tabs v-model="activeName">
                        <el-tab-pane label="图库" name="first">
                          <el-table :data="gridData" :height="400" highlight-current-row @current-change="CheckImgFile">
                            <el-table-column align="center" width="100" property="title" label="名称"></el-table-column>
                            <el-table-column property="cover" align="center" label="缩略图">
                              <template slot-scope="scope">
                                <el-image style="width: 50px" :src="scope.row.cover"></el-image>
                              </template>
                            </el-table-column>

                            <el-table-column width="50" property="width" label="宽"></el-table-column>

                            <el-table-column width="50" property="height" label="高"></el-table-column>

                            <el-table-column align="center" property="desc" label="简介"></el-table-column>
                          </el-table>

                          <div style="margin-top: 10px; text-align: right">
                            <el-button @click="AddPhoto" size="mini" type="primary" icon="el-icon-check">插入</el-button>
                          </div>
                        </el-tab-pane>
                      </el-tabs>

                      <el-button slot="reference" class="photo_btn" size="mini" icon="el-icon-picture" circle>
                      </el-button>
                    </el-popover>

                    <el-button class="stop_btn" size="mini" icon="el-icon-s-help" circle @click="stopBtn"></el-button>

                    <el-button class="start_btn" size="mini" icon="el-icon-s-flag" circle @click="startBtn"></el-button>

                    <el-button class="copy_btn tag-work-data" size="mini" icon="el-icon-attract" round
                      :data-clipboard-text="work_data" @click="copy_work_data">复制项目源码</el-button>
                  </div>

                  <div class="editor_down" :style="{ height: Editor_ContentHeight }">
                    <codemirror :style="{ display: !is_editor ? 'none' : 'block', fontSize: fontSize + 'px' }"
                      class="cmEditor" ref="cmEditor" :value="code" :options="cmOptions" @ready="onCmReady"
                      @focus="onCmFocus" @input="onCmCodeChange" />

                    <div :style="{
                      display: !is_photo ? 'none' : 'block',
                      height: Editor_ContentHeight,
                    }" class="photo_view">
                      <el-image class="photo_view_img" :src="is_photo_url" :style="{ 'margin-top': 20 + 'px' }">
                      </el-image>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="CourseWidth">
                <div class="course-wrapper" :style="{ height: Editor_Height }">
                  <div v-if="ChangeFile">
                    <div class="course-up">
                      <svg t="1657759629893" style="float:left;margin-top:15px;margin-left:10px;" class="icon"
                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9815" width="20"
                        height="20">
                        <path
                          d="M945.08544 366.6432l-425.97376-183.1936a20.5312 20.5312 0 0 0-8.12544-1.6896c-2.7648 0-5.52448 0.5632-8.14592 1.6896L76.87168 366.6432c-8.98048 3.84512-14.92992 13.65504-14.92992 24.59136 0 10.9568 5.94944 20.74112 14.92992 24.60672L502.8352 599.04a20.29056 20.29056 0 0 0 16.27136 0l331.1872-142.43328v145.7152c-17.75104 9.40032-30.08512 29.8496-30.08512 53.62688 0 23.7824 12.33408 44.22656 30.08512 53.62688v50.83136h43.6224v-50.82112c17.76128-9.40032 30.1056-29.8496 30.1056-53.63712s-12.34432-44.2368-30.1056-53.63712V437.84704l51.16416-22.00576c8.97536-3.8656 14.9248-13.65504 14.9248-24.60672 0-10.93632-5.94944-20.74624-14.9248-24.59136z m-434.0992 269.16352a47.96928 47.96928 0 0 1-19.03104-3.95776L226.4064 517.632v157.70112c0 129.16224 193.65888 167.936 254.208 167.936h60.69248c45.35808 0 254.22848-38.77376 254.22848-167.936v-157.696l-265.55904 114.21184a47.76448 47.76448 0 0 1-18.9952 3.95776z"
                          fill="#1296db" p-id="9816"></path>
                      </svg>

                      <span class="course-title">

                        课程提示</span>

                      <span class="exitfull_btn tag-course-data" :data-clipboard-text="course_content"
                        @click="copy_course_data"><i class="el-icon-attract"></i>复制源码</span>
                      <span @click="FullScreen" class="full_btn"><i class="el-icon-full-screen"></i>录入</span>
                    </div>
                    <div class="course-content" :style="{ height: Editor_Height }" v-html="course_content" />
                  </div>

                  <div v-else>
                    <div class="course-up">
                      <span class="course-title">课后作业</span>
                      <span class="course-change" @click="ChangeTinyFile"><i class="el-icon-sort"> </i>切换</span>
                      <span class="exitfull_btn tag-homework-data" :data-clipboard-text="homework_content"
                        @click="copy_homework_data"><i class="el-icon-attract"></i>复制源码</span>
                      <span @click="FullScreen" class="full_btn"><i class="el-icon-full-screen"></i>录入</span>
                    </div>
                    <div class="course-content" :style="{ height: Editor_Height }" v-html="homework_content" />
                  </div>
                </div>
              </el-col>
            </el-row>

            <div :style="{ marginRight: courseinfo_width + 'px' }" class="zoom_lib_out">
              <el-button class="photo_btn" size="mini" circle @click="AddFontsize">

                <svg t="1657157128936" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5229" width="15" height="15">
                  <path
                    d="M998.4 102.4h-102.4V0h-102.4v102.4h-102.4v102.4h102.4v102.4h102.4V204.8h102.4V102.4zM435.2 0h-204.8l-204.8 1024h102.4L240.64 460.8h286.72l112.64 563.2h102.4l-204.8-1024zM261.12 358.4l51.2-256h143.36l51.2 256z"
                    p-id="5230" fill="#1296db"></path>
                </svg>

              </el-button>
            </div>


            <div :style="{ marginRight: courseinfo_width + 'px' }" class="zoom_lib_in">
              <el-button class="photo_btn" size="mini" circle @click="ReduceFontsize">

                <svg t="1657099353894" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="3999" width="15" height="15">
                  <path
                    d="M665.6 0h307.2v102.4h-307.2zM409.6 0H204.8L0 1024h102.4L215.04 460.8h286.72L614.4 1024h102.4L512 0zM235.52 358.4l51.2-256h143.36l51.2 256z"
                    p-id="4000" fill="#1296db"></path>
                </svg>

              </el-button>
            </div>

            <div :style="{ marginRight: courseinfo_width + 'px' }" class="zoom_lib_mid">
              <el-button class="photo_btn" size="mini" circle @click="ResetFontsize">

                <svg t="1657099451772" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="7318" width="15" height="15">
                  <path
                    d="M812.992 180.992a58.24 58.24 0 0 1 43.008 17.024 58.24 58.24 0 0 1 16.96 42.944v482.048c0 16.64-5.76 30.848-17.472 42.496a57.856 57.856 0 0 1-42.496 17.536H210.944a57.856 57.856 0 0 1-42.496-17.536 57.856 57.856 0 0 1-17.472-42.496V240.96a58.24 58.24 0 0 1 16.96-42.944 58.24 58.24 0 0 1 43.008-17.024h602.048z m0-60.992H210.944c-16 0.64-31.36 4.032-46.016 9.984-14.72 6.08-27.648 14.72-39.04 26.048-11.264 11.328-20.096 24.32-26.432 39.04-6.4 14.656-9.536 30.016-9.536 46.016v481.984c0 16 3.2 31.36 9.536 46.016 6.336 14.72 15.168 27.712 26.496 39.04a119.808 119.808 0 0 0 84.992 35.008h602.048c16 0 31.36-3.008 46.016-9.024 14.72-6.016 27.648-14.72 39.04-25.984 11.264-11.392 20.096-24.384 26.432-39.04 6.4-14.656 9.536-30.016 9.536-46.016V241.088c0-16-3.2-31.36-9.536-46.08a124.416 124.416 0 0 0-26.496-38.976 117.952 117.952 0 0 0-39.04-26.048 135.104 135.104 0 0 0-45.952-9.984z m-120 180.992a28.352 28.352 0 0 0-21.504 8.96 29.568 29.568 0 0 0-8.512 21.056v300.928a29.12 29.12 0 0 0 30.016 30.08 29.12 29.12 0 0 0 30.016-30.08V330.944a29.184 29.184 0 0 0-30.08-30.016v0.064z m-361.984 0a28.8 28.8 0 0 0-20.992 8.96 28.8 28.8 0 0 0-8.96 21.056v300.928a29.184 29.184 0 0 0 29.952 30.08 29.12 29.12 0 0 0 30.08-30.08V330.944a29.568 29.568 0 0 0-8.576-20.992 28.352 28.352 0 0 0-21.504-8.96zM512 361.024a32.896 32.896 0 0 0-21.504 9.472 29.12 29.12 0 0 0-8.512 21.504v30.016A29.12 29.12 0 0 0 512 451.072a29.12 29.12 0 0 0 30.016-29.056v-30.016a28.352 28.352 0 0 0-8.96-21.504A33.792 33.792 0 0 0 512 361.024zM512 512a29.12 29.12 0 0 0-30.08 30.016v30.016a29.12 29.12 0 0 0 30.08 30.016 29.12 29.12 0 0 0 30.016-30.016v-30.016a28.8 28.8 0 0 0-8.96-20.992 28.8 28.8 0 0 0-21.056-8.96V512z"
                    fill="#1296db" p-id="7319"></path>
                </svg>

              </el-button>
            </div>


            <el-row>
              <el-col :span="24">
                <div class="console-wrapper" ref="console">
                  <div class="console_up">
                    <span class="console_btn">控制台</span>

                    <span v-if="Console_Height == '40px'" @click="OpenConsole" class="close_console"
                      :style="{ height: Console_Height }"><i class="el-icon-arrow-up"></i>
                    </span>

                    <span v-else @click="CloseConsole" class="close_console" :style="{ height: Console_Height }"><i
                        class="el-icon-arrow-down"></i>
                    </span>
                    <span v-if="Console_Height !== '40px'" @click="clearBtn" class="clear_btn"><i
                        class="clear_btn_icon el-icon-brush"></i>清空</span>
                  </div>
                  <div id="xterm" class="console_down"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-drawer title="文本编辑器-课程指引" z-index="1000" :visible.sync="drawer1" :direction="direction" size="50%">
      <tinymce v-model="course_content" :height="Tiny_Height" />
    </el-drawer>

    <el-drawer title="文本编辑器-作业要求" :visible.sync="drawer2" :direction="direction" size="50%">
      <tinymce v-model="homework_content" :height="Tiny_Height" />
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { codemirror } from "vue-codemirror";
//import "codemirror/theme/mdn-like.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/neo.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！

require("codemirror/mode/python/python"); // 这里引入的模式的js，根据设置的mode引入，一定要引入！！

//代码补全提示

import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";

//选中行背景
import "codemirror/addon/selection/active-line"; //光标行背景高亮,styleActiveLine 设置为true

//代码折叠
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/markdown-fold";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/indent-fold";

//括号自动闭合
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/edit/closebrackets";

//搜索功能
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/addon/search/jump-to-line.js'

import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'

//终端显示
import "xterm/css/xterm.css";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import { AttachAddon } from "xterm-addon-attach";

import { savePyWork, getPyWorkContent } from "@/api/educational";
import {
  updatePyWorkZanList,
  updatePyWorkKeepList,
  updatePyWorkLooks,
} from "@/api/community";

import Tinymce from "@/components/Tinymce";
import Clipboard from "clipboard";

export default {
  name: "pyeditor",
  data() {
    return {
      drawer1: false,
      drawer2: false,
      direction: "ltr",
      ChangeFile: true,

      school_logo: "",
      title: "",
      code: "",
      cmOptions: {
        tabSize: 4,
        indentUnit: 4,
        mode: "python",
        //theme: "mdn-like",
        theme: "idea",
        lint: true,
        lineNumbers: true,
        line: true,

        dragDrop: true,

        //括号自动闭合
        matchBrackets: true,
        autoCloseBrackets: true,

        styleActiveLine: false, // 显示选中行的样式
        extraKeys: {
          Ctrl: "autocomplete",
          Tab: (cm) => {
            if (cm.somethingSelected()) {      // 存在文本选择
              cm.indentSelection('add');    // 正向缩进文本
            } else {                    // 无文本选择
              cm.replaceSelection(Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");  // 光标处插入 indentUnit 个空格
            }
          }
        },
        autofocus: true,
        // 代码折叠
        gutters: [
          "CodeMirror-lint-markers",
          "CodeMirror-linenumbers",
          "CodeMirror-foldgutter",
        ],
        foldGutter: true, // 启用行槽中的代码折叠
        // more CodeMirror options...
      },

      //websocket
      term: null,
      socket: null, //代码传输接口
      fileSocket: null, //文件接口
      contentSocket: null, //目录接口
      started: false,

      //高度适配
      Editor_Height: 0,
      Editor_ContentHeight: 0,
      Console_Height: 0,
      Tiny_Height: 0,

      //宽度适配
      FilesWidth: 5,
      EditorWidth: 16,
      CourseWidth: 8,

      work_id: null,

      works_title: "我的作品",
      work_title: "main.py",
      file_id: 0,
      work_num: 1,

      filelist: [
        {
          id: 0,
          type: "py",
          label: "main.py",
          code: "",
          url: "",
          iconSkin: "el-icon-document",
          selected: true,
        },
      ],

      editor_mode: "",

      course_content: "请输入内容", //课程指引
      homework_content: "请输入内容", //作业要求
      workinfo: {}, //python作品详情

      is_photo: false, //判断当前文件是否未图片
      is_photo_url: "",
      is_photo_width: 0, //资源宽度
      is_photo_height: 0, //资源高度

      gridData: [
        {
          title: "网格",
          type: "jpeg",
          cover: "https://scratchshop.oss-cn-shanghai.aliyuncs.com/grid.jpeg",
          width: 480,
          height: 360,
          desc: "海龟绘图-网格",
        },
        {
          title: "background",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/background.png",
          width: 960,
          height: 720,
          desc: "飞机大战背景",
        },

        {
          title: "starbg",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/starbg.png",
          width: 960,
          height: 720,
          desc: "星球背景",
        },


        {
          title: "outerspace",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/outerspace.png",
          width: 600,
          height: 800,
          desc: "星际迷航背景",
        },

        {
          title: "ship",
          type: "jpg",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/ship.jpg",
          width: 93,
          height: 89,
          desc: "飞船",
        },
        {
          title: "alien",
          type: "jpg",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/alien.jpg",
          width: 89,
          height: 96,
          desc: "",
        },
        {
          title: "planet",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/planet.png",
          width: 167,
          height: 47,
          desc: "星球",
        },
        {
          title: "astronaut",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/astronaut.png",
          width: 77,
          height: 100,
          desc: "宇航员",
        },

        {
          title: "bg",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/bg.png",
          width: 800,
          height: 600,
          desc: "",
        },
        {
          title: "CrazySmile",
          type: "bmp",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/CrazySmile.bmp",
          width: 100,
          height: 100,
          desc: "",
        },
        {
          title: "smile",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/smile.png",
          width: 274,
          height: 412,
          desc: "",
        },
        {
          title: "dog1",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/dog1.png",
          width: 254,
          height: 216,
          desc: "",
        },
        {
          title: "dog2",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/dog2.png",
          width: 254,
          height: 216,
          desc: "",
        },
        {
          title: "gameover",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/gameover.png",
          width: 800,
          height: 450,
          desc: "",
        },
        {
          title: "gamestart",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/gamestart.png",
          width: 650,
          height: 450,
          desc: "",
        },
        {
          title: "flowers",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/flowers.gif",
          width: 130,
          height: 95,
          desc: "",
        },

        {
          title: "budinggou",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/budinggou.gif",
          width: 450,
          height: 450,
          desc: "布丁狗",
        },

        {
          title: "dahei",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/dahei.png",
          width: 450,
          height: 450,
          desc: "大黑",
        },
        {
          title: "云朵",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E4%BA%91%E6%9C%B5.png",
          width: 2250,
          height: 2250,
          desc: "云朵",
        },
        {
          title: "小绿旗",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E5%B0%8F%E7%BB%BF%E6%97%97.png",
          width: 2250,
          height: 2250,
          desc: "小绿旗",
        },
        {
          title: "心",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E5%BF%83.png",
          width: 2250,
          height: 2250,
          desc: "心",
        },
        {
          title: "树干",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E6%A0%91%E5%B9%B2.png",
          width: 800,
          height: 600,
          desc: "树干",
        },
        {
          title: "点名",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E7%82%B9%E5%90%8D.png",
          width: 500,
          height: 150,
          desc: "点名",
        },
        {
          title: "蝴蝶",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E8%9D%B4%E8%9D%B6.png",
          width: 2250,
          height: 2250,
          desc: "蝴蝶",
        },
        {
          title: "铃铛",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%93%83%E9%93%9B.png",
          width: 2250,
          height: 2250,
          desc: "铃铛",
        },
        {
          title: "黑夜",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%BB%91%E5%A4%9C.png",
          width: 960,
          height: 720,
          desc: "黑夜",
        },
        {
          title: "黑猫",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%BB%91%E7%8C%AB.png",
          width: 4260,
          height: 3600,
          desc: "黑猫",
        },

        {
          title: "email",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/email.png",
          width: 800,
          height: 600,
          desc: "email",
        },
        {
          title: "tv",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/tv.png",
          width: 1000,
          height: 600,
          desc: "tv",
        },
        {
          title: "kuang",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/kuang.png",
          width: 200,
          height: 50,
          desc: "kuang",
        },
        {
          title: "qrcode_bg",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/qrcode_bg.png",
          width: 400,
          height: 400,
          desc: "qrcode_bg",
        },
        {
          title: "A",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/A.gif",
          width: 100,
          height: 100,
          desc: "A",
        },
        {
          title: "B",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/B.gif",
          width: 100,
          height: 100,
          desc: "B",
        },
        {
          title: "C",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/C.gif",
          width: 100,
          height: 100,
          desc: "C",
        },
        {
          title: "D",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/D.gif",
          width: 100,
          height: 100,
          desc: "D",
        },
        {
          title: "E",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/E.gif",
          width: 100,
          height: 100,
          desc: "E",
        },
        {
          title: "F",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/F.gif",
          width: 100,
          height: 100,
          desc: "F",
        },
        {
          title: "G",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/G.gif",
          width: 100,
          height: 100,
          desc: "G",
        },
        {
          title: "H",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/H.gif",
          width: 100,
          height: 100,
          desc: "H",
        },
        {
          title: "I",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/I.gif",
          width: 100,
          height: 100,
          desc: "I",
        },
        {
          title: "J",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/J.gif",
          width: 100,
          height: 100,
          desc: "J",
        },
        {
          title: "K",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/K.gif",
          width: 100,
          height: 100,
          desc: "K",
        },
        {
          title: "L",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/L.gif",
          width: 100,
          height: 100,
          desc: "L",
        },
        {
          title: "M",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/M.gif",
          width: 100,
          height: 100,
          desc: "M",
        },
        {
          title: "N",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/N.gif",
          width: 100,
          height: 100,
          desc: "N",
        },
        {
          title: "O",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/O.gif",
          width: 100,
          height: 100,
          desc: "O",
        },
        {
          title: "P",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/P.gif",
          width: 100,
          height: 100,
          desc: "P",
        },
        {
          title: "Q",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Q.gif",
          width: 100,
          height: 100,
          desc: "Q",
        },
        {
          title: "R",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/R.gif",
          width: 100,
          height: 100,
          desc: "R",
        },
        {
          title: "S",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/S.gif",
          width: 100,
          height: 100,
          desc: "S",
        },
        {
          title: "T",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/T.gif",
          width: 100,
          height: 100,
          desc: "T",
        },
        {
          title: "U",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/U.gif",
          width: 100,
          height: 100,
          desc: "U",
        },
        {
          title: "V",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/V.gif",
          width: 100,
          height: 100,
          desc: "V",
        },
        {
          title: "W",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/W.gif",
          width: 100,
          height: 100,
          desc: "W",
        },
        {
          title: "X",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/X.gif",
          width: 100,
          height: 100,
          desc: "X",
        },
        {
          title: "Y",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Y.gif",
          width: 100,
          height: 100,
          desc: "Y",
        },
        {
          title: "Z",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Z.gif",
          width: 100,
          height: 100,
          desc: "Z",
        },

        {
          title: "地球",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%9C%B0%E7%90%83.gif",
          width: 62,
          height: 62,
          desc: "地球",
        },
        {
          title: "海王星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%B5%B7%E7%8E%8B%E6%98%9F.gif",
          width: 72,
          height: 72,
          desc: "海王星",
        },
        {
          title: "火星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E7%81%AB%E6%98%9F.gif",
          width: 45,
          height: 45,
          desc: "火星",
        },

        {
          title: "金星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E9%87%91%E6%98%9F.gif",
          width: 50,
          height: 50,
          desc: "金星",
        },
        {
          title: "木星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%9C%A8%E6%98%9F.gif",
          width: 120,
          height: 120,
          desc: "木星",
        },
        {
          title: "水星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%B0%B4%E6%98%9F.gif",
          width: 20,
          height: 20,
          desc: "水星",
        },
        {
          title: "天王星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%A4%A9%E7%8E%8B%E6%98%9F.gif",
          width: 83,
          height: 83,
          desc: "天王星",
        },
        {
          title: "土星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%9C%9F%E6%98%9F.gif",
          width: 153,
          height: 152,
          desc: "土星",
        },

        {
          title: "America",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/America.png",
          width: 1200,
          height: 800,
          desc: "America",
        },

        {
          title: "Britain",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/Britain.png",
          width: 1200,
          height: 800,
          desc: "Britain",
        },

        {
          title: "China",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/China.png",
          width: 1200,
          height: 800,
          desc: "China",
        },

        {
          title: "Russia",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/Russia.png",
          width: 1200,
          height: 800,
          desc: "Russia",
        },
        {
          title: "playground",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/playground.png",
          width: 638,
          height: 581,
          desc: "playground",
        },

        {
          title: "dot",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/dot.png",
          width: 1200,
          height: 800,
          desc: "dot",
        },

        {
          title: "letter",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/letter.png",
          width: 1200,
          height: 800,
          desc: "letter",
        },
        {
          title: "rabbit",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/rabbit.gif",
          width: 29,
          height: 30,
          desc: "rabbit",
        },

        {
          title: "sun",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/sun.png",
          width: 1000,
          height: 800,
          desc: "sun",
        },

        {
          title: "刘亦菲1",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%88%98%E4%BA%A6%E8%8F%B21.png",
          width: 500,
          height: 500,
          desc: "刘亦菲1",
        },

        {
          title: "刘亦菲2",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%88%98%E4%BA%A6%E8%8F%B22.png",
          width: 500,
          height: 500,
          desc: "刘亦菲2",
        },

        {
          title: "半袖",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%8D%8A%E8%A2%96.png",
          width: 800,
          height: 800,
          desc: "半袖",
        },
        {
          title: "卡通眼镜帅哥",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%8D%A1%E9%80%9A%E7%9C%BC%E9%95%9C%E5%B8%85%E5%93%A5.png",
          width: 500,
          height: 500,
          desc: "卡通眼镜帅哥",
        },

        {
          title: "哭泣",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%93%AD%E6%B3%A3.png",
          width: 500,
          height: 500,
          desc: "哭泣",
        },

        {
          title: "大笑",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%A4%A7%E7%AC%91.png",
          width: 500,
          height: 500,
          desc: "大笑",
        },

        {
          title: "树",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E6%A0%91.png",
          width: 1080,
          height: 1920,
          desc: "树",
        },

        {
          title: "测颜值",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E6%B5%8B%E9%A2%9C%E5%80%BC.png",
          width: 700,
          height: 700,
          desc: "测颜值",
        },

        {
          title: "甄嬛哭",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E7%94%84%E5%AC%9B%E5%93%AD.png",
          width: 500,
          height: 500,
          desc: "甄嬛哭",
        },

        {
          title: "缩略图",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E7%BC%A9%E7%95%A5%E5%9B%BE.png",
          width: 260,
          height: 260,
          desc: "缩略图",
        },

        {
          title: "花",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%8A%B1.png",
          width: 690,
          height: 920,
          desc: "花",
        },

        {
          title: "螃蟹",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%9E%83%E8%9F%B9.png",
          width: 800,
          height: 1067,
          desc: "螃蟹",
        },

        {
          title: "豹子",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%B1%B9%E5%AD%90.png",
          width: 500,
          height: 675,
          desc: "豹子",
        },

        {
          title: "按钮",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1207/%E6%8C%89%E9%92%AE.png",
          width: 88,
          height: 88,
          desc: "按钮",
        },

        {
          title: "十秒挑战",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1207/%E5%8D%81%E7%A7%92%E6%8C%91%E6%88%98.png",
          width: 300,
          height: 400,
          desc: "十秒挑战",
        },

        {
          title: "星图",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/1207/%E6%98%9F%E5%9B%BE.gif",
          width: 320,
          height: 360,
          desc: "星图",
        }

      ],

      activeName: "first",
      has_select_img: null,

      s_link: false, //小助手标志位

      type: "", //新建的类型
      current_id: 1,
      current_node: null, //当前节点
      console_offset: 40,
      is_editor: false,
      PythonList: [], //python文件列表

      SPCHART: [
        ".",
        "?",
        "*",
        ":",
        "<",
        ">",
        "/",
        "|",
        ",",
        ";",
        "'",
        "`",
        "~",
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "(",
        ")",
        "-",
        "。",
        "+",
        "=",
        "{",
        "}",
        "[",
        "]",
      ],
      read_level: 0,
      fontSize: 16,

      current_version: '1.0.0',
      filestate: 'free',

      initfilelist: [],
      courseinfo_width: 0,

      is_opened: true
    };
  },

  watch: {
    started() {
      console.log("程序启动状态");
      console.log(this.started);

      if (this.started) {
        this.started = false;
        this.StartPy();
      }
    },

    content() {
      console.log("富文本源码");
      console.log(this.content);
    },
  },

  components: {
    codemirror,
    Tinymce,
  },

  computed: {
    codemirror() {
      return this.$refs.cmEditor.codemirror;
    },
    work_data() {
      return JSON.stringify(this.filelist);
    },
  },

  mounted() {
    console.log("the current CodeMirror instance object:", this.codemirror);
    /*document.getElementsByClassName("header-menu-container")[0].style.display =
      "none";*/

    this.initSocket();

    //初始化文件管理服务器
    this.fileSocket = new WebSocket("ws://localhost:1885");
    this.fileSocket.onmessage = this.fileSocketRx;
    this.fileSocketOnClose();
    this.fileSocketOnOpen();
    this.fileSocketOnError();

    //初始化目录刷新接口
    this.contentSocket = new WebSocket("ws://localhost:1886");
    this.contentSocket.onmessage = this.onContentSocketRx;

    this.contentSocketOnClose();
    this.contentSocketOnOpen();
    this.contentSocketOnError();


    this.$nextTick(() => {
      this.initDOM();

      //判断内容宽度
      this.courseinfo_width = this.$refs.courseinfo.clientWidth;
      console.log('课程引导框的宽度')
      console.log(this.courseinfo_width)

    });

    if (this.$route.query.type == "1") {
      console.log("课堂成果-数据");
      console.log(this.$route.params.data);

      this.filelist = JSON.parse(this.$route.params.data);

      for (let k = 0; k < this.filelist.length; k++) {
        this.filelist[k].id = k;
        if (this.filelist[k].selected) {
          this.code = this.filelist[k].code;
          this.work_title = this.filelist[k].label;
        }
      }
      this.course_content = this.$route.params.data1;
    } else if (this.$route.query.type == "2") {
      console.log("授课模板-数据");
      console.log(this.$route.params.data);

      this.filelist = JSON.parse(this.$route.params.data);

      for (let k = 0; k < this.filelist.length; k++) {
        this.filelist[k].id = k;
        if (this.filelist[k].selected) {
          this.code = this.filelist[k].code;
          this.work_title = this.filelist[k].label;
        }
      }
      this.course_content = this.$route.params.data1;
    } else if (this.$route.query.type == "3") {
      console.log("课程引导-数据");
      console.log(this.$route.params.data);
      this.course_content = this.$route.params.data1;
    }
  },

  beforeDestroy() {
    this.socket.close();
    this.term.dispose();
  },

  methods: {

    AddFontsize() {
      console.log('增加字号')
      this.fontSize = this.fontSize + 1;
      setTimeout(() => {
        this.$refs.cmEditor.codemirror.refresh();
      }, 10);
    },

    ReduceFontsize() {
      console.log('减少字号')
      this.fontSize = this.fontSize - 1;
      setTimeout(() => {
        this.$refs.cmEditor.codemirror.refresh();
      }, 10);
    },
    ResetFontsize() {
      console.log('复原字号')
      this.fontSize = 16;
      setTimeout(() => {
        this.$refs.cmEditor.codemirror.refresh();
      }, 10);
    },

    searchCode() {

      this.$refs.cmEditor.codemirror.execCommand('find')

    },

    initDOM() {
      this.Editor_Height =
        document.documentElement.clientHeight * 0.75 - 80 + "px";
      this.Console_Height = document.documentElement.clientHeight * 0.25 + "px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight * 0.75 - 130 + "px";
      this.Tiny_Height = document.documentElement.clientHeight - 110 + "px";
    },

    OpenFolder(node, data) {
      console.log("打开文件目录");
      console.log(node);
      data.operate = "open";
      this.fileSocket.send(JSON.stringify(data));
    },

    StartPy() {
      console.log("运行PY文件");
      document.getElementById("xterm").innerText = "";
      this.socket = new WebSocket("ws://localhost:1884");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
      this.socketOnClose();
      this.socketOnOpen();
      this.socketOnError();
    },

    AddFloderFoot() {
      console.log("根目录新建文件夹");
      this.$prompt("请输入文件夹名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            for (let k = 0; k < this.SPCHART.length; k++) {
              console.log(this.SPCHART[k]);
              if (value.indexOf(this.SPCHART[k]) !== -1) {
                this.$message.warning("文件夹名称不能包含特殊字符");
                return;
              }
            }

            for (let k = 0; k < this.filelist.length; k++) {
              if (this.filelist[k].type == "folder") {
                if (
                  this.filelist[k].label.toLowerCase() == value.toLowerCase()
                ) {
                  this.$message.warning(
                    "名称" + '"' + value + '"已被占用,请选取其他名称。'
                  );
                  return;
                }
              }
            }

            console.log("无选中节点");
            var pyfile = {
              id: Date.parse(new Date()),
              type: "folder",
              path: value,
              label: value,
              code: "",
              url: "",
              iconSkin: "el-icon-folder-opened",
              operate: "write",
              children: [],
            };
            this.filelist.push(pyfile);
            //实时传输新建文件夹
            this.fileSocket.send(JSON.stringify(pyfile));



            var that = this;
            setTimeout(function () {

              if (that.current_node.type == 'py') {

                that.fileSocket.send(JSON.stringify(that.current_node));
                console.log('覆盖')
                console.log(that.current_node)
              }

            }, 100);	// 还是每秒执行一次，不是累加的

          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消新建",
          });
        });
    },

    onCmReady(cm) {
      console.log("the editor is readied!", cm);
    },
    onCmFocus(cm) {
      console.log("the editor is focused!", cm);
    },
    onCmCodeChange(newCode) {
      console.log("this is new code", newCode);


      console.log(this.current_node)
      console.log(this.fileSocket)

      this.current_node.code = newCode;

      if (this.current_node.type == "py") {
        this.$refs.tree.updateKeyChildren(
          this.current_node.id,
          this.current_node
        );
        this.current_node.operate = "write";
        this.fileSocket.send(JSON.stringify(this.current_node));
      }
    },

    startBtn() {
      if (!this.current_node) {
        console.log('当前文件')
        console.log(this.current_node)
        this.$message.warning('请选择需要运行的PY文件');
        return;
      }
      else {
        if (this.current_node.type !== 'py') {
          this.$message.warning('请选择需要运行的PY文件');
          return;
        }
      }

      this.is_started = true;
      document.getElementById("xterm").innerText = "";
      this.socket.removeEventListener("message", this.onSocketRx);
      this.socket.close();
      this.socket = new WebSocket("ws://localhost:1884");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
      this.socketOnClose();
      this.socketOnOpen();
      this.socketOnError();
    },

    stopBtn() {
      document.getElementById("xterm").innerText = "";
      this.socket.removeEventListener("message", this.onSocketRx);
      this.socket.close();
      this.socket = new WebSocket("ws://localhost:1883");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
    },

    //终端显示
    initTerm() {
      const term = new Terminal({
        fontSize: 14,
        cursorBlink: true,
        rows: 11, //行数
        theme: {
          foreground: "white", //字体
          background: "#3f3f3f", //背景色
          cursor: "help", //设置光标
        },
      });
      const attachAddon = new AttachAddon(this.socket);
      const fitAddon = new FitAddon();
      term.loadAddon(attachAddon);
      term.loadAddon(fitAddon);

      term.open(document.getElementById("xterm"));

      fitAddon.fit();
      term.focus();
      this.term = term;
    },
    initSocket() {
      this.socket = new WebSocket("ws://localhost:1883");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
      this.socketOnClose();
      this.socketOnOpen();
      this.socketOnError();
    },

    socketOnOpen() {
      this.socket.onopen = () => {
        // 链接成功后
        //this.initTerm();
      };
    },

    socketOnClose() {
      this.socket.onclose = () => {
        // console.log('close socket')
      };
    },
    socketOnError() {
      this.socket.onerror = () => {
        // console.log('socket 链接失败')
      };
    },
    //文件websocket
    fileSocketOnOpen() {
      this.fileSocket.onopen = () => {
        // 链接成功后
        console.log("websocket连接成功");

      };
    },
    fileSocketOnClose() {
      this.fileSocket.onclose = () => {
        this.started = true;
        console.log("fileSocket.onclose");
      };
    },
    fileSocketOnError() {
      this.fileSocket.onerror = () => {
        // console.log('socket 链接失败')
      };
    },


    //目录刷新接口
    contentSocketOnOpen() {
      this.contentSocket.onopen = () => {
        // 链接成功后
        console.log("目录刷新websocket连接成功");
        //this.ClearFileDir();
      };
    },

    ClearFileDir() {
      console.log("清空文件目录");
      var data = {
        cmd: "clear",
        path: "",
      };
      this.contentSocket.send(JSON.stringify(data));
    },

    contentSocketOnClose() {
      this.contentSocket.onclose = () => {
        console.log("contentSocket.onclose");

        console.log('文件目录已清空')


      };
    },
    contentSocketOnError() {
      this.contentSocket.onerror = () => {
        // console.log('socket 链接失败')
      };
    },


    onSocketRx(event) {
      console.log("onSocketRx");
      console.log(event.data);
    },

    fileSocketRx(event) {
      console.log('文件处理数据返回')
      console.log(event.data)
      this.filestate = event.data;

    },


    onContentSocketRx(event) {
      console.log("清空目录返回1");
      console.log(event.data);

      var data = event.data.split(',');
      console.log(data);

      var version = data[0];
      var name = data[1];

      console.log('软件版本:' + version)
      console.log('软件名称:' + name)

      if (name == 'steam-slink') {
        if (this.current_version == version) {
          console.log('最新版本')

        }
        else {
          console.log('有新版本')
        }
      }


      console.log('--------------------------')
      this.initfilelist = [];
      var that = this;


      var files = function (filelist) {
        for (let i = 0; i < filelist.length; i++) {
          var file = filelist[i].children;
          if (file) {
            if (file.length > 0) {
              files(file)
            }
          }
          console.log('节点数据-1')
          console.log(filelist[i])
          that.initfilelist.push(filelist[i]);
        }
      };

      files(this.filelist);

      console.log('数据遍历完毕')

      console.log(this.initfilelist);

      for (var i = 0; i < this.initfilelist.length; i++) {
        (function (t, data) {   // 注意这里是形参
          setTimeout(function () {
            console.log(`这是第 ${t} 次，这是其他参数：${data}`);

            console.log(that.initfilelist[t])

            that.initfilelist[t].operate = "write";
            if (!that.initfilelist[t].path) {
              that.initfilelist[t].path = '';
            }

            that.fileSocket.send(JSON.stringify(that.initfilelist[t]));


          }, 100 * t);	// 还是每秒执行一次，不是累加的
        })(i, '其他参数')   // 注意这里是实参，这里把要用的参数传进去
      }




    },


    clearBtn() {
      this.term.clear();
    },

    CloseConsole() {
      console.log("关闭调试框");

      this.Editor_Height = document.documentElement.clientHeight - 100 + "px";
      this.Console_Height = "40px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight - 100 - 50 + "px";
    },

    OpenConsole() {
      console.log("打开调试框");
      this.Editor_Height =
        document.documentElement.clientHeight * 0.75 - 80 + "px";
      this.Console_Height = document.documentElement.clientHeight * 0.25 + "px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight * 0.75 - 130 + "px";
    },

    OpenFiles() {
      console.log("打开文件管理");
      this.FilesWidth = 4;
    },

    CloseFiles() {
      console.log("关闭文件管理");
      this.FilesWidth = 0;
    },

    FullScreen() {
      console.log("进入全屏");
      if (this.ChangeFile) {
        this.drawer1 = true;
        this.drawer2 = false;
      } else {
        this.drawer1 = false;
        this.drawer2 = true;
      }
    },
    ExitFullScreen() {
      console.log("退出全屏");
      this.EditorWidth = 16;
      this.CourseWidth = 8;
      this.OpenFiles();
      this.OpenConsole();
    },

    //远程加载py文件代码
    getcode(e) {
      var that = this;
      axios({
        method: "get",
        url: e,
        responseType: "blob",
      }).then(function (response) {
        console.log(response.data);
        let blob = response.data;
        let reader = new FileReader();
        reader.readAsBinaryString(blob);
        reader.onload = (e) => {
          console.log(e.target.result);
          that.code = e.target.result;
        };
      });
    },

    //文档目录
    FileOnselect(data, node, component) {
      console.log("节点被点击");
      console.log(this.filelist);

      console.log(data);
      console.log(node);
      console.log(component);

      //兼容v1版本无path属性
      if (!data.path) {
        data.path = ''
      }


      this.current_node = data;
      this.$refs.tree.setCurrentKey(data.id);

      if (data.type == "py") {
        this.is_photo = false;
        this.is_editor = true;
        this.work_title = data.path + data.label;
        this.$refs.cmEditor.codemirror.setValue(data.code);

        setTimeout(() => {
          this.$refs.cmEditor.codemirror.refresh();
        }, 10);

        data.operate = "write";

        this.fileSocket.send(JSON.stringify(data));
      } else if (data.type == "folder") {
        console.log("文件夹被点击");
      } else {
        this.work_title = data.label;
        this.is_photo = true;
        this.is_editor = false;
        this.is_photo_url = data.url;
        this.is_photo_width = data.width;
        this.is_photo_height = data.height;
      }
    },

    //新建作品
    CreateWork() {
      this.$prompt("请输入作品名称,记得保存当前作品哦！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            this.works_title = value;
            this.file_id = 0;

            (this.filelist = [
              {
                id: 0,
                type: "py",
                label: "main.py",
                code: "",
                url: "",
                iconSkin: "el-icon-document",
                selected: true,
              },
            ]),
              (this.code = "");
            this.work_id = null;

            this.$message({
              type: "success",
              message: "新建作品成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "取消新建",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消新建",
          });
        });
    },

    ChangeWorkTitle() {
      this.$prompt("请输入作品名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            this.works_title = value;
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "取消修改",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
        });
    },

    ChangeTinyFile() {
      console.log("切换文件");
      this.ChangeFile = !this.ChangeFile;
    },

    AddPyFile() {
      this.$prompt("请输入文件名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            for (let k = 0; k < this.SPCHART.length; k++) {
              console.log(this.SPCHART[k]);
              if (value.indexOf(this.SPCHART[k]) !== -1) {
                this.$message.warning("文件名不能包含特殊字符");
                return;
              }
            }

            for (let k = 0; k < this.current_node.children.length; k++) {
              if (this.current_node.children[k].type == "py") {
                if (
                  this.current_node.children[k].label.toLowerCase() ==
                  value.toLowerCase() + ".py"
                ) {
                  this.$message.warning(
                    "名称" + '"' + value + '"已被占用,请选取其他名称。'
                  );
                  return;
                }
              }
            }

            var pyfile = {
              id: Date.parse(new Date()),
              type: "py",
              path: this.current_node.path + "/",
              label: value + ".py",
              code: "",
              url: "",
              iconSkin: "el-icon-document",
              children: [],
              operate: "write",
            };

            this.$refs.tree.append(pyfile, this.current_node);
            this.fileSocket.send(JSON.stringify(pyfile));

            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(pyfile.id);
              this.work_title = pyfile.path + pyfile.label;
              this.current_node = pyfile;
              this.$refs.cmEditor.codemirror.setValue("#请在这里编写代码\n");

              this.PythonList.push(pyfile);

              setTimeout(() => {
                this.$refs.cmEditor.codemirror.refresh();
              }, 10);
            });
          }
        })
        .catch((error) => {
          console.log("错误");
          console.log(error);
          this.$message({
            type: "info",
            message: "取消添加",
          });
        });
    },

    AddPyFileFoot() {
      console.log("根目录创建Py文件");

      this.$prompt("请输入文件名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            for (let k = 0; k < this.SPCHART.length; k++) {
              console.log(this.SPCHART[k]);
              if (value.indexOf(this.SPCHART[k]) !== -1) {
                this.$message.warning("文件名不能包含特殊字符");
                return;
              }
            }

            for (let k = 0; k < this.filelist.length; k++) {
              if (this.filelist[k].type == "py") {
                if (
                  this.filelist[k].label.toLowerCase() ==
                  value.toLowerCase() + ".py"
                ) {
                  this.$message.warning(
                    "名称" + '"' + value + '"已被占用,请选取其他名称。'
                  );
                  return;
                }
              }
            }

            var pyfile = {
              id: Date.parse(new Date()),
              type: "py",
              path: "",
              label: value + ".py",
              code: "",
              url: "",
              iconSkin: "el-icon-document",
              children: [],
              operate: "write",
            };
            this.filelist.push(pyfile);
            this.fileSocket.send(JSON.stringify(pyfile));

            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(pyfile.id);
              this.work_title = pyfile.path + pyfile.label;
              this.current_node = pyfile;
              this.$refs.cmEditor.codemirror.setValue("#请在这里编写代码\n");

              this.PythonList.push(pyfile);

              setTimeout(() => {
                this.$refs.cmEditor.codemirror.refresh();
              }, 10);
            });
          }
        })
        .catch((error) => {
          console.log("错误");
          console.log(error);
          this.$message({
            type: "info",
            message: "取消添加",
          });
        });
    },

    //获得自由创作作品详情

    getPyWorkContent() {
      getPyWorkContent({
        work_id: this.work_id,
      }).then((res) => {
        console.log("python作品详情");
        console.log(res);
        this.works_title = res.pyWork.title;
        console.log("项目信息");
        console.log(JSON.parse(res.pyWork.work_url));
        this.filelist = JSON.parse(res.pyWork.work_url);
        this.workinfo = res.pyWork;

        for (let k = 0; k < this.filelist.length; k++) {
          if (this.filelist[k].selected) {
            this.file_id = this.filelist[k].id;
            this.work_title = this.filelist[k].label;
            this.code = this.filelist[k].code;
          }
        }

        this.file_id = this.filelist.length - 1;
      });
    },

    //更新作品浏览次数
    updatePyWorkLooks() {
      updatePyWorkLooks({
        work_id: this.work_id,
      }).then((res) => {
        console.log("更新PYTHON浏览次数");
        console.log(res);
      });
    },

    //添加PY文件
    /* AddPyFile() {
      console.log("添加项目文件");

      this.work_id = this.work_id+1;

      const pyfile = {
        id: this.work_id,
        type: "py",
        label: "new1.py",
        code: "",
        url: "",
        iconSkin: "el-icon-document",
        selected: true,
      };
      
      this.filelist.push(pyfile);
      this.code = "";
    },

    */

    //发布作品

    publicwork() {
      console.log("发布项目");
      console.log(this.works_title);
      console.log(JSON.stringify(this.filelist));

      for (let k = 0; k < this.filelist.length; k++) {
        console.log("项目文件列表");
        console.log(this.filelist[k]);
      }

      if (this.work_id) {
        console.log("更新项目");
        savePyWork({
          work_id: this.work_id,
          work_type: "2",
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          abstract: "",
          explain: "",
          is_only: false,
        }).then((res) => {
          console.log("更新PYTHON项目");
          console.log(res);
          if (res.is_update) {
            this.$message.success("项目更新成功");
            this.work_id = res.work_id;
          }
        });
      } else {
        console.log("新建项目");
        savePyWork({
          work_type: "2",
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          abstract: "",
          explain: "",
          is_only: false,
        }).then((res) => {
          console.log("保存PYTHON项目");
          console.log(res);
          if (res.is_create) {
            this.$message.success("项目发布成功");
            this.work_id = res.work_id;
          }
        });
      }
    },

    //作品保存
    savework() {
      console.log("保存项目");
      console.log(this.works_title);
      console.log(JSON.stringify(this.filelist));

      for (let k = 0; k < this.filelist.length; k++) {
        console.log("项目文件列表");
        console.log(this.filelist[k]);
      }

      if (this.work_id) {
        console.log("更新项目");
        savePyWork({
          work_id: this.work_id,
          work_type: "1",
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          abstract: "",
          explain: "",
          is_only: false,
        }).then((res) => {
          console.log("更新PYTHON项目");
          console.log(res);
          if (res.is_update) {
            this.$message.success("项目更新成功");
            this.work_id = res.work_id;
          }
        });
      } else {
        console.log("新建项目");
        savePyWork({
          work_type: "1",
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          abstract: "",
          explain: "",
          is_only: false,
        }).then((res) => {
          console.log("保存PYTHON项目");
          console.log(res);
          if (res.is_create) {
            this.$message.success("项目保存成功");
            this.work_id = res.work_id;
          }
        });
      }
    },

    //删除文件
    DeleteFile() {
      console.log("删除文件");
      console.log(this.current_node);

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = this.current_node;

          if (data.type == "py" || data.type == "picture") {
            data.operate = "delete";
            this.$refs.tree.remove(data.id);

            console.log(data);
            this.fileSocket.send(JSON.stringify(data));

            for (let k = 0; k < this.PythonList.length; k++) {
              if (this.PythonList[k].id == data.id) {
                this.PythonList.splice(k, 1);
              }
            }

            //设定文件选中状态
            if (this.PythonList.length !== 0) {
              this.$refs.tree.setCurrentKey(
                this.PythonList[this.PythonList.length - 1].id
              );
              this.work_title = this.PythonList[
                this.PythonList.length - 1
              ].label;
              this.current_node = this.$refs.tree.getNode(
                this.PythonList[this.PythonList.length - 1].id
              );
              this.$refs.cmEditor.codemirror.setValue(
                this.PythonList[this.PythonList.length - 1].code
              );

              this.is_photo = false;
              this.is_editor = true;

              this.fileSocket.send(
                JSON.stringify(this.PythonList[this.PythonList.length - 1])
              );
            }
          } else if (data.type == "folder") {
            console.log("文件夹");

            if (this.current_node.children.length !== 0) {
              this.$message.warning("目录下有文件存在,不能删除!");
              return;
            }

            data.operate = "delete";
            this.$refs.tree.remove(data.id);
            this.fileSocket.send(JSON.stringify(data));
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //文件重命名
    //文件重命名
    RenameFile(node, data) {
      console.log("文件重命名");
      console.log(node);
      console.log(data);

      this.$prompt("请输入文件名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            for (let k = 0; k < this.SPCHART.length; k++) {
              console.log(this.SPCHART[k]);
              if (value.indexOf(this.SPCHART[k]) !== -1) {
                this.$message.warning("文件名不能包含特殊字符");
                return;
              }
            }

            if (data.type == "py") {
              if (data.label == value + ".py") {
                this.$message.warning("名称不能相同");
                return;
              } else {
                //删除原文件
                data.oldname = data.label;
                data.label = value + ".py";
                data.operate = "rename";
                console.log(data);
                this.fileSocket.send(JSON.stringify(data));
              }
            } else if (
              data.type == "picture" ||
              data.type == "png" ||
              data.type == "gif" ||
              data.type == "jpg" ||
              data.type == "jpeg" ||
              data.type == "bmp"
            ) {
              if (data.label.split(".")[0] == value) {
                this.$message.warning("名称不能相同");
                return;
              } else {
                //删除原文件
                data.oldname = data.label;
                data.label = value + "." + data.oldname.split(".")[1];
                data.operate = "rename";
                console.log(data);
                this.fileSocket.send(JSON.stringify(data));
              }
            }
          } else {
            this.$message({
              type: "info",
              message: "取消修改",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
        });
    },

    //作品点赞

    updatePyWorkZanList() {
      updatePyWorkZanList({
        work_id: this.work_id,
        operate_state: this.workinfo.zanState ? "2" : "1",
      }).then((res) => {
        console.log("python作品点赞");
        console.log(res);
        if (res.is_update) {
          this.$message.success("点赞成功");
        } else if (res.is_delete) {
          this.$message.success("取消点赞");
        }
        this.getPyWorkContent();
      });
    },

    //作品收藏
    updatePyWorkKeepList() {
      updatePyWorkKeepList({
        work_id: this.work_id,
        operate_state: this.workinfo.keepState ? "2" : "1",
      }).then((res) => {
        console.log("python作品收藏");
        console.log(res);
        if (res.is_update) {
          this.$message.success("收藏成功");
        } else if (res.is_delete) {
          this.$message.success("取消收藏");
        }
        this.getPyWorkContent();
      });
    },

    //添加图片资源

    AddPhoto() {
      console.log("添加图片");
      if (this.has_select_img == null) {
        this.$message.warning("请选择图片");
        return;
      } else {

        if (this.current_node) {
          if (this.current_node.type == "folder") {
            console.log("插入子目录");

            const photofile = {
              id: Date.parse(new Date()),
              path: this.current_node.path + "/",
              type: 'picture',
              label: this.has_select_img.title + '.' + this.has_select_img.type,
              width: this.has_select_img.width,
              height: this.has_select_img.height,
              code: "",
              url: this.has_select_img.cover,
              iconSkin: "el-icon-picture",
              operate: "write",
              children: [],
            };

            console.log('插入图片目录')
            console.log(this.current_node)

            this.$refs.tree.append(photofile, this.current_node);
            this.fileSocket.send(JSON.stringify(photofile));


          } else if (
            this.current_node.type == "py" ||
            this.current_node.type == "picture"
          ) {
            const photofile = {
              id: Date.parse(new Date()),
              path: this.current_node.path + "/",
              type: 'picture',
              label: this.has_select_img.title + '.' + this.has_select_img.type,
              width: this.has_select_img.width,
              height: this.has_select_img.height,
              code: "",
              url: this.has_select_img.cover,
              iconSkin: "el-icon-picture",
              operate: "write",
              children: [],
            };

            this.$refs.tree.insertAfter(photofile, this.current_node);
            this.fileSocket.send(JSON.stringify(photofile));
          } else {
            console.log("插入根目录");

            const photofile = {
              id: Date.parse(new Date()),
              path: "",
              type: 'picture',
              label: this.has_select_img.title + '.' + this.has_select_img.type,
              width: this.has_select_img.width,
              height: this.has_select_img.height,
              code: "",
              url: this.has_select_img.cover,
              iconSkin: "el-icon-picture",
              operate: "write",
              children: [],
            };

            this.$refs.tree.append(photofile);
            this.fileSocket.send(JSON.stringify(photofile));
          }
        } else {
          console.log("插入根目录");

          const photofile = {
            id: Date.parse(new Date()),
            path: "",
            type: 'picture',
            label: this.has_select_img.title + '.' + this.has_select_img.type,
            width: this.has_select_img.width,
            height: this.has_select_img.height,
            code: "",
            url: this.has_select_img.cover,
            iconSkin: "el-icon-picture",
            operate: "write",
            children: [],
          };

          this.$refs.tree.append(photofile);
          this.fileSocket.send(JSON.stringify(photofile));
        }

        this.$message.success("插入成功");
      }
    },

    //选择图库
    CheckImgFile(val) {
      console.log(val);
      this.has_select_img = val;
    },

    copy_work_data() {
      var clipboard = new Clipboard(".tag-work-data");
      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },

    copy_course_data() {
      var clipboard_course = new Clipboard(".tag-course-data");
      clipboard_course.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard_course.destroy();
      });
      clipboard_course.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard_course.destroy();
      });
    },

    copy_homework_data() {
      var clipboard_homework = new Clipboard(".tag-homework-data");
      clipboard_homework.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard_homework.destroy();
      });
      clipboard_homework.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard_homework.destroy();
      });
    },

    handleDragStart(node, ev) {
      console.log("drag start", node);
      console.log(ev);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label);
      console.log(ev);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label);
      console.log(ev);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label);
      console.log(ev);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log("tree drag end: ", dropNode && dropNode.label, dropType);
      console.log(ev);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
      console.log(ev);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "二级 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.editor_wrapper {
  background: #e2f4ff;
  height: calc(100vh - 60px);
  overflow: hidden;

  .header {
    width: 100%;
    height: 60px;
    background: #1d1f22;

    .header-logo {
      width: 120px;
      height: 40px;
      margin-left: 20px;
      margin-top: 10px;

      .header-logo-img {
        width: 100%;
      }
    }

    .header-title {
      line-height: 55px;

      .header-title-content {
        margin-left: 10px;
        color: white;
        font-size: 18px;
        cursor: pointer;
      }

      .work_files {
        margin-left: 40px;
        color: white;
        font-size: 16px;
        cursor: pointer;
      }

      .work_title {
        margin-left: 40px;
        color: white;
        font-size: 14px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 40px;
        padding-right: 40px;
        background: grey;
        border-radius: 10px;
        cursor: pointer;
      }

      .savework {
        float: right;
        margin-right: 20px;
        margin-top: 15px;
      }

      .publishwork {
        float: right;
        margin-right: 10px;
        margin-top: 15px;
      }
    }

    .file {
      position: absolute;
      left: 170px;
      top: 20px;
      font-size: 16px;
      font-weight: 700;
      color: white;
    }

    .title_input {
      position: absolute;
      width: 150px;
      left: 250px;
      top: 16px;
    }
  }


  .search_tool {
    position: absolute;
    right: 20px;
    margin-top: -250px;
    z-index: 1000;
  }

  .zoom_lib_out {
    position: absolute;
    right: 20px;
    margin-top: -200px;
    z-index: 1000;
  }

  .zoom_lib_in {
    position: absolute;
    right: 20px;
    margin-top: -100px;
    z-index: 1000;
  }

  .zoom_lib_mid {
    position: absolute;
    right: 20px;
    margin-top: -150px;
    z-index: 1000;
  }

  .content {
    width: 100%;
    height: calc(100vh - 60px);
    background: #3f3f3f;

    .left {
      // margin-left: 10px;
      //margin-top: 10px;
      // margin-bottom: 10px;
      border-right: 2px solid black;
      height: calc(100vh - 80px);

      .left_up {
        width: 100%;
        height: 50px;
        background: white;
        color: #333333;

        .left_up_title {
          line-height: 50px;
          margin-left: 10px;
          font-weight: bold;
        }

        .left_up_icon {
          float: right;
          margin-top: 10px;
          margin-right: 10px;
          padding: 5px;
          color: #333333;
          cursor: pointer;
        }
      }

      .left_down {
        //  margin-top: 10px;
        width: 100%;
        height: calc(100vh - 110px);
        background: white;

        .filelist {
          background: white;
          color: #606266;

          .filecontrol {
            float: right;
            margin-right: 10px;
            margin-top: 4px;
            font-size: 14px;
          }
        }
      }
    }

    .right {
      height: calc(100vh - 80px);

      .editor-wrapper {
        .editor_up {
          height: 50px;
          background: white;
          line-height: 50px;

          .files_open_icon {
            margin-top: 10px;
            margin-left: 10px;
            padding: 5px;
            background: #212121;
            cursor: pointer;
            color: #9d9d9d;
          }

          .editor_up_title {
            color: #9d9d9d;
            margin-left: 10px;
            font-weight: bold;
          }

          .filename {
            color: #9d9d9d;
            margin-left: 10px;
            font-weight: bold;
          }

          .start_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: white;
            background: #2b2b2b;
          }

          .copy_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: #333333;
            background: white;
            border: 0px;
            border: 1px solid #333333;
          }

          .stop_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: white;
            background: #2b2b2b;

            border: 0px;

          }

          .photo_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: white;
            background: #2b2b2b;
            border: 0px;
          }
        }

        .editor_down {
          background: #ffffff;
          overflow-y: scroll !important;

          .photo_view {
            overflow-y: scroll;

            .photo_view_img {
              width: 50%;
              margin-left: 25%;
            }
          }
        }
      }

      .course-wrapper {
        background: white;
        border-left: 1px solid gainsboro;

        .course-up {
          height: 50px;
          background: white;
          line-height: 50px;

          .course-title {
            color: #757575;
            margin-left: 10px;
            font-weight: bold;
          }

          .course-change {
            color: #757575;
            margin-left: 10px;
            font-weight: bold;
            cursor: pointer;
          }

          .full_btn {
            float: right;
            margin-right: 10px;
            font-size: 14px;
            color: #6e6e6e;
            font-weight: bold;
            cursor: pointer;
          }

          .exitfull_btn {
            float: right;
            margin-right: 10px;
            font-size: 14px;
            color: #6e6e6e;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .course-content {
          padding: 20px;
          overflow-y: scroll;
        }

        .content {
          background: red;
        }
      }

      .console-wrapper {
        .console_up {
          height: 40px;
          background: #f2f6fc;
          line-height: 40px;

          color: #333333;

          .console_btn {
            margin-left: 10px;
            color: #333333;
            font-weight: bold;
          }

          .clear_btn {
            float: right;
            margin-right: 20px;
            cursor: pointer;
            font-weight: bold;
            font-size: 16px;
          }

          .close_console {
            font-size: 16px;
            float: right;
            margin-right: 20px;
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style> 
 
<style>
.editor_wrapper .el-input__inner {
  background: #e2f4ff;
}

.CodeMirror {
  height: auto !important;
}

.editor_wrapper .el-tree-node__content {
  width: 100%;
}

</style>